<template>
  <b-modal
    :id="`promo-checks-${checksType}`"
    :title="title"
  >
    <b-form-checkbox-group
      v-model="checks"
      stacked
      :options="options"
      @input="$emit('target-selection', $event)"
    />
  </b-modal>
</template>

<script>
import { BModal, BFormCheckboxGroup } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BFormCheckboxGroup,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    checksType: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    selections: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const checks = ref([])
    if (props.selections.length) {
      props.selections.forEach(sel => {
        checks.value.push(sel)
      })
    }
    return {
      checks,
    }
  },
}
</script>

<style>

</style>
